import { MenuBar, QrTypeMenu, TransactionStatus } from '@back-office/ui';

export const statusBar: MenuBar[] = [
  {
    status: null,
    wording: 'transaction_list.status.all_status',
  },
  {
    status: TransactionStatus.Authorized,
    wording: 'transaction_list.status.authorized',
  },
  {
    status: TransactionStatus.AuthorizedVoided,
    wording: 'transaction_list.status.authorized_voided',
  },
  {
    status: TransactionStatus.Cancelled,
    wording: 'transaction_list.status.cancelled',
  },
  {
    status: TransactionStatus.Cleared,
    wording: 'transaction_list.status.cleared',
  },
  {
    status: TransactionStatus.ClearedPendingRefund,
    wording: 'transaction_list.status.cleared_pending_refund',
  },
  {
    status: TransactionStatus.ClearedRefunded,
    wording: 'transaction_list.status.cleared_refunded',
  },
  {
    status: TransactionStatus.Confirming,
    wording: 'transaction_list.status.confirming',
  },
  {
    status: TransactionStatus.DropOff,
    wording: 'transaction_list.status.drop_off',
  },
  {
    status: TransactionStatus.Pending,
    wording: 'transaction_list.status.pending',
  },

  {
    status: TransactionStatus.RefundRequestPending,
    wording: 'transaction_list.status.refund_request_pending',
  },
  {
    status: TransactionStatus.Rejected,
    wording: 'transaction_list.status.rejected',
  },
  {
    status: TransactionStatus.Processing,
    wording: 'transaction_list.status.processing',
  },
];

export const qrTypeItem: QrTypeMenu[] = [
  {
    status: null,
    wording: 'transaction_list.qr_types.all',
  },
  {
    status: 'StaticQR',
    wording: 'transaction_list.qr_types.static_qr',
  },
  {
    status: 'DynamicQR',
    wording: 'transaction_list.qr_types.dynamic_qr',
  },
];

export enum ResponseMessage {
  OK = 'OK',
  Error = 'Error!',
}

export const SORTED_REQUEST_TYPES = [
  'Purchased Item not Available',
  'System Error',
  'Double Charging',
  'Double Payment',
  'Purchased item defective',
  'Unauthorized Payment',
  'Customer not satisfied with the service',
];

export const excludedTerminalId = ['99999999', '99999992'];

export const AUTO_GENERATED_REF1_LENGTH = 20;
export const MINIMUM_AVAILABLE_AMOUNT = 1;
export const MAXIMUM_AVAILABLE_AMOUNT = 500000;
export const REF_1_MAX_LENGTH = 20;
export const REF_2_MAX_LENGTH = 320;
export const DESCRIPTION_MAX_LENGTH = 500;
export const OTP_TIMEOUT = 60;
export const LOCKED_USER_ERROR_MESSAGE = 'account has been locked';
export const VOID_TYPE = 'void';
export const REFUND_TYPE = 'refund';
export const FORGOT_PASSWORD_CLICK_TIME = 'FORGOT_PASSWORD_CLICK_TIME';
export const BUTTON_CLICK_WAIT = 15;
export const SMS_OTP_TIMEOUT_IN_SEC = 60;
export const REF2_EDITED_MAX_LENGTH = 150;
export const STATUS_CODE_SUCCESS = 1000;
export const STATUS_CODE_REJECT = 8904;
export const STATUS_CODE_BAD_REQUEST = 1101;
export const STATUS_CODE_API_LIMIT = 9903;
export const STATUS_CODE_NOT_AUTHORIZED = 9500;
export const STATUS_CODE_NOT_FOUND = 1211;
export const STATUS_CODE_GENERIC_INTERNAL_ERROR = 8900;
export const ERROR_MESSAGES_GENERIC_INTERNAL_ERROR = 'internal server error(s)';
export const TIMER_DELAY_MILLISECOND = 1000;
export const FILE_SIZE_LIMIT = 10;
export const PAYMENT_CHECKER_O1_PERMISSION = 'payment.upload.checker.01';
export const PAYMENT_CHECKER_O2_PERMISSION = 'payment.upload.checker.02';
export const PAYMENT_MAKER_PERMISSION = 'payment.upload.maker';
export const PAYMENT_VIEW_PERMISSION = 'payment.upload.view';
